import React from 'react';

import { JobType, MifMarkerUnsupervisedAnalysisJob } from 'interfaces/job';
import JobReportTab from './JobReportTab';

interface Props {
  pageSize?: number;
  selectedStudyId?: string;
}

const MifMarkerUnsupervisedAnalysis: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  pageSize = 10,
  selectedStudyId,
}) => {
  return (
    <JobReportTab<MifMarkerUnsupervisedAnalysisJob>
      tabTitle="mIF Marker Unsupervised Analysis"
      jobType={JobType.MifMarkerUnsupervisedAnalysis}
      emptyStateMessage="No mIF unsupervised analysis results are available yet."
      pageSize={pageSize}
      selectedStudyId={selectedStudyId}
    />
  );
};

export default MifMarkerUnsupervisedAnalysis;
